<template>
  <div class="q-col-12 q-col-md-3 q-pt-1 suggestions__container"
       :class="{'q-border-bottom q-px-0 q-pb-2': isMobileView}" id="suggestions__container" v-if="hasAnyResults">
    <p v-if="!isMobileView" class="q-text-muted q-col-12 suggestions__header q-mt-0 q-mb-0 q-fw-semibold q-text-start">
      {{ SmartSearchTranslations.autocomplete.suggestionsText }}</p>
    <ul id="suggestionsListNew" class="q-list-group q-list-group-flush q-w-100 q-px-0 suggestions__list">
      <SingleSuggestion v-for="suggestion in getNewSuggestions" :key="suggestion.query" :suggestion="suggestion"/>
    </ul>
  </div>
</template>

<script setup lang="ts">
import {storeToRefs} from "pinia";
import SingleSuggestion from '@/components/AutocompletePopup/ShowResults/Suggestions/SingleSuggestion.vue';
import {useSuggestionStore} from "@/store/AutocompletePopup/SuggestionStore";
import {usePopupStore} from "@/store/AutocompletePopup/PopupStore";
import {inject} from "vue";
import {SmartSearchTranslationsInterface} from "@/core/types";
import {useMobileViewStore} from "@/store/MobileViewStore";

const suggestionStore = useSuggestionStore()
const {getNewSuggestions} = storeToRefs(suggestionStore)
const mobileViewStore = useMobileViewStore();
const {isMobileView} = storeToRefs(mobileViewStore)

const popupStore = usePopupStore()
const {hasAnyResults} = storeToRefs(popupStore)


// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const SmartSearchTranslations = inject<SmartSearchTranslationsInterface>('SmartSearchTranslations')!

</script>

<style scoped>
@media (max-width: 767px) {
  #suggestionsListNew {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: flex-start;
    overflow-x: scroll;
  }
}

</style>
